import { Q as slot } from "../../../chunks/index2.js";
import { a as afterNavigate } from "../../../chunks/client.js";
function _layout($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    afterNavigate(() => {
      document.getElementById("app")?.scrollTo(0, 0);
    });
    $$renderer2.push(`<!--[-->`);
    slot($$renderer2, $$props, "default", {});
    $$renderer2.push(`<!--]-->`);
  });
}
export {
  _layout as default
};
